import "./App.css";
import { useRef } from "react";
import About from "./components/about/About";
import Skills from "./components/Skills";
import Service from "./components/Service";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Touchwithme from "./components/Touchwithme";
import Footer from "./components/Footer";
// import Casestudy from "./components/Casestudy";
import Casestudybreif from "./components/Casestudybreif";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Coding from "./components/Coding";
import Navbar from "./components/Navbar";
// import GitHubContributions from "./components/GitHubContributions";
// import test from "./components/test";

function App() {
  const projectRef = useRef(null);
  const experianceRef = useRef(null);
  const codingRef = useRef(null);
  const contactRef = useRef(null);
  const homeRef = useRef(null);
  // const homeRef = useRef(null);
  return (
    <div className="App">
      <Toaster position="top-center" reverseOrder={false} />
      {/* <About homeRef={homeRef} />
      <Skills />
      <Service />
      <Experience />
      <div ref={homeRef}>
        <Projects />
      </div>
      <Touchwithme />
      <Footer />
      <Casestudy/> */}
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navbar
                  projectRef={projectRef}
                  experianceRef={experianceRef}
                  codingRef={codingRef}
                  contactRef={contactRef}
                  homeRef={homeRef}
                />
                <div ref={homeRef}>
                  <About projectRef={projectRef} />
                </div>

                <Skills />
                <Service />
                <div ref={experianceRef}>
                  <Experience />
                </div>

                <div ref={projectRef}>
                  <Projects />
                </div>
                <div ref={codingRef}>
                  <Coding />
                </div>
                {/* <div>
                  <GitHubContributions />
                </div> */}

                {/* <Casestudy /> */}

                <div ref={contactRef}>
                  <Touchwithme />
                </div>

                <Footer />
              </>
            }
          />
          <Route path="/case-study/:title" element={<Casestudybreif />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
